import { render } from "./AmenitiesList.vue?vue&type=template&id=cf0d2a52&scoped=true"
import script from "./AmenitiesList.vue?vue&type=script&lang=js"
export * from "./AmenitiesList.vue?vue&type=script&lang=js"

import "./AmenitiesList.vue?vue&type=style&index=0&id=cf0d2a52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0d2a52"]])

export default __exports__